import { WBFlex } from '@admiin-com/ds-web';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { useFromToTypeFromTaskDirection } from '../../../../../pages/TaskCreation/useFromToTypeFromTaskDirection';
import { useAto } from '../../../../../hooks/useAto/useAto';
import { Bill } from '../../../../PayBill/PayBillCreateForm';
import AutoCompleteLookupV2 from '../../../../AutoCompleteLookup/AutoCompleteLookupV2';
import { getNestedError } from '../utils';
import { getPendingNonEntityUserSignersFromAnnotations } from '../../../../../helpers/signature';
import { useTaskCreationContext } from '../../../../../features/providers/TaskCreationProvider/useTaskCreationContext';

export const SignPayFormTo = ({
  isNonAbnEntity,
}: {
  isNonAbnEntity?: boolean;
  scannedTax: Bill | null;
}) => {
  const { t } = useTranslation();
  const { control, watch, setValue, trigger } = useFormContext();
  const { fromType, toType } = useFromToTypeFromTaskDirection({
    name: 'futureTaskInput',
  });

  const { taskDirection, taskType } = useTaskCreationContext();

  const isTaxType = React.useMemo(() => taskType === 'tax', [taskType]);

  const inputs = React.useMemo(
    () => ({
      from: {
        label: t('from', { ns: 'taskbox' }),
        name: `futureTaskInput.from`,
        type: 'text',
        defaultValue: null,
        placeholder:
          taskDirection === 'SENDING'
            ? t('entitySearchPlaceholder', { ns: 'taskbox' })
            : t('contactSearchPlaceholder', { ns: 'taskbox' }),
        rules: { required: t('fromRequired', { ns: 'taskbox' }) },
      },
      to: {
        label: t('to', { ns: 'taskbox' }),
        name: `futureTaskInput.to`,
        type: 'text',
        placeholder:
          taskDirection === 'RECEIVING'
            ? t('entitySearchPlaceholder', { ns: 'taskbox' })
            : t('contactSearchPlaceholder', { ns: 'taskbox' }),
        defaultValue: null,
        rules: { required: t('toRequired', { ns: 'taskbox' }) },
      },
    }),
    [t, taskDirection]
  );

  const entityId = watch('futureTaskInput.to.id');

  const ato = useAto();
  React.useEffect(() => {
    if ((isNonAbnEntity || taskType === 'tax') && ato)
      setValue('futureTaskInput.from', ato, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
  }, [isNonAbnEntity, ato, taskType, setValue]);

  const annotationsJson = useWatch({ name: 'annotations', control });
  const signers = useMemo(
    () => getPendingNonEntityUserSignersFromAnnotations(annotationsJson),
    [annotationsJson]
  );

  React.useEffect(() => {
    if (signers.length === 1 && taskDirection === 'SENDING') {
      if (watch('futureTaskInput.to')) return;
      if (signers[0].signerType === 'GUEST') {
        // TODO: need to create new contact if contact type is guest signer
        setValue('futureTaskInput.to', signers[0], {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
      }
    }
  }, [signers, setValue, taskDirection, watch]);

  return (
    <WBFlex flexDirection={['column', 'row']} gap={[0, 4]}>
      {isTaxType ||
        taskDirection === 'SENDING' ||
        (isNonAbnEntity && (
          <Controller
            control={control}
            name={inputs.from.name}
            rules={inputs.from.rules}
            defaultValue={inputs.from.defaultValue}
            render={
              ({ field, formState: { errors } }) => (
                // isTaxType  ? (
                <div />
              )
              // ) : (
              //   <AutoCompleteLookupV2
              //     {...field}
              //     noPopupIcon
              //     label={inputs.from.label}
              //     disabled={
              //       taskDirection === 'SENDING' || isNonAbnEntity || isTaxType
              //     }
              //     placeholder={inputs.from.placeholder}
              //     ocrCreate
              //     entityId={entityId}
              //     type={fromType}
              //     helperText={
              //       (getNestedError(errors, field.name)?.message as string) ?? ''
              //     }
              //     error={!!getNestedError(errors, field.name)}
              //   />
              // )
            }
          />
        ))}

      <Controller
        control={control}
        name={inputs.to.name}
        rules={inputs.to.rules}
        defaultValue={inputs.to.defaultValue}
        render={({ field, formState: { errors } }) =>
          isTaxType || taskDirection === 'RECEIVING' ? (
            <div />
          ) : (
            <AutoCompleteLookupV2
              {...field}
              noPopupIcon
              label={inputs.to.label}
              placeholder={inputs.to.placeholder}
              disabled={taskDirection === 'RECEIVING'}
              type={toType}
              helperText={
                (getNestedError(errors, field.name)?.message as string) ?? ''
              }
              error={!!getNestedError(errors, field.name)}
            />
          )
        }
      />
    </WBFlex>
  );
};
